import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [userIsLoggedIn, setUserIsLoggedIn] = useState(false);
    const [user, setUser] = useState(null);
    const [deckCreated, setDeckCreated] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
  // Allow overriding API host/port with environment variables for local testing
  const host = process.env.REACT_APP_API_HOST || "webapp.risecardgame.com";
  const port = process.env.REACT_APP_API_PORT ? Number(process.env.REACT_APP_API_PORT) : 3777;
    
    process.env['NODE_TLS_REJECT_UNAUTHORIZED'] = '0';
    // Always send cookies for cross-site API calls
    axios.defaults.withCredentials = true;
    useEffect(() => {
  const token = Cookies.get('logToken');

  if (token) {
    axios.post(
      `https://${host}:${port}/verify-token`,
      {},
      {
        withCredentials: true,
        headers: token ? { Authorization: `Bearer ${token}` } : {}
      }
    )
    .then(res => {
      // Le payload peut être soit { decoded: { user: {...} } } soit { decoded: {...} }
      if (res.data && res.data.decoded) {
        const decoded = res.data.decoded;
        const userData = decoded.user || decoded;
        setUserIsLoggedIn(true);
        setUser(userData);
        // Expose le rôle dans localStorage pour que PrivateRoutes puisse y accéder
        if (userData && userData.role) {
          try { localStorage.setItem('role', userData.role); } catch(e){}
        }
      } else {
        setUserIsLoggedIn(false);
        setUser(undefined);
        try { localStorage.removeItem('role'); } catch(e){}
      }
    })
    .catch(err => {
      console.error("Erreur lors de l'appel à /verify-token:", err);
      setUserIsLoggedIn(false);
      setUser(undefined);
      Cookies.remove('logToken');
      try { localStorage.removeItem('role'); } catch(e){}
    });
  } else {
    setUserIsLoggedIn(false);
    setUser(undefined);
    try { localStorage.removeItem('role'); } catch(e){}
  }
}, []);




    const login = (userData, token) => {
        setUser(userData);
        setUserIsLoggedIn(true);
        Cookies.set('logToken', token, { expires: 7 }); // Définir le cookie avec une expiration de 7 jours
    // Stocke le rôle pour la navigation côté client
    try { localStorage.setItem('role', userData?.role || (userData?.user && userData.user.role) || ''); } catch(e){}
    };

    const logout = () => {
        window.location.href="/"
        setUser(null);
        setUserIsLoggedIn(false);
        Cookies.remove('logToken');
    try { localStorage.removeItem('role'); } catch(e){}

    };

    const SvgFilters = () => (
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" style={{ height: 0, width: 0, position: 'absolute' }}>
            <defs>
                <filter id="shadow" height="130%">
                    <feDropShadow dx="2" dy="2" stdDeviation="2" floodColor="black" />
                </filter>
            </defs>
        </svg>
    );


    return (
        <AuthContext.Provider value={{ host, port, userIsLoggedIn, setUserIsLoggedIn, user, setUser, deckCreated, setDeckCreated, login, logout, showFilter, setShowFilter, SvgFilters }}>
            {children}
        </AuthContext.Provider>
    );
}


export const useAuth = () => useContext(AuthContext);
